import details from 'reducers/profile/details';
import password from 'reducers/profile/password';
import { combineReducers } from 'redux-immutable';

export default combineReducers({ details, password });
